import { FC, useState } from 'react';
import styled from 'styled-components';

import { remify } from '#/service/utils';

import AccordionItem from '../Accordion/AccordionItem';
import {
  AccordionContainer,
  AccordionTitle,
} from '../Accordion/AccordionItem.styled';
import { FooterLink } from './FooterLink';
import Logo from './Logo';
import { FooterContentProps } from './types';

const LogoContainer = styled.div`
  width: 100%;
  text-align: center;
  margin: ${remify(50)} 0;
`;

const FooterAccordion: FC<FooterContentProps> = ({ columns }) => {
  const [expandedPanel, setExpandedPanel] = useState('');

  const handleChange = (panel: string) => {
    setExpandedPanel(expandedPanel === panel ? '' : panel);
  };

  return (
    <AccordionContainer>
      {columns.map(({ key, title, items }) => (
        <AccordionItem
          itemKey={key}
          key={key}
          onTrigger={handleChange}
          open={key === expandedPanel}
          triggerElement={<AccordionTitle>{title}</AccordionTitle>}
        >
          {items.map(({ key, ...rest }) => (
            <FooterLink key={key} {...rest} />
          ))}
        </AccordionItem>
      ))}
      <LogoContainer>
        <Logo />
      </LogoContainer>
    </AccordionContainer>
  );
};

export default FooterAccordion;
